import { useBoxFiltersContent } from "./content/filters.js";
import { useBoxGridContent } from "./content/grid.js";
import { useBoxesBreadcrumbContent, useBoxesTitleContent } from "./content/heading.js";
import { useBoxTabsContent } from "./content/tabs.js";
import { useTopHitsContent } from "./content/topHits.js";
import type { BoxesContent } from "./contract.js";

/** Every boxes-page section's content, the same under every template. */
export function useBoxesContent(): BoxesContent {
  return {
    breadcrumb: useBoxesBreadcrumbContent(),
    title: useBoxesTitleContent(),
    tabs: useBoxTabsContent(),
    filters: useBoxFiltersContent(),
    topHits: useTopHitsContent(),
    grid: useBoxGridContent(),
  };
}
